import React from 'react'
import { strings } from '../../../localization/strings'
import { TextField } from '@material-ui/core/index'
import Button from '@material-ui/core/Button'
import SelectSimple from '../../components/selectSimple'

class Component extends React.Component {
    initialState = {
        editing: false,
        country: '',
        province: '',
        city: '',
        streetAddress: '',
        streetNumber: '',
        postalCode: '',
        floor: '',
        apartment: '',
    }

    state = {
        ...this.initialState,
        ...this.props.initialValue,
        country: this.props.countryList[0],
    }

    submitOkData = () => {
        var {
            country,
            province,
            city,
            streetAddress,
            streetNumber,
            postalCode,
            floor,
            apartment,
        } = { ...this.state }
        return {
            country,
            province,
            city,
            streetAddress,
            streetNumber,
            postalCode,
            floor,
            apartment,
        }
    }

    render() {
        const { canOpen, errors } = this.props
        const { editing } = this.state
        const { countryList, provinceList } = this.props
        const {
            country,
            province,
            city,
            streetAddress,
            streetNumber,
            postalCode,
            floor,
            apartment,
        } = this.state
        const formatReq = (string) => (
            <div>
                {string}
                <span style={{ color: 'red' }}> *</span>
            </div>
        )

        const style = {
            field: { margin: '10px auto', width: '100%' },
        }

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '50px 0px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        margin: '20px auto 10px auto',
                    }}
                >
                    {this.props.title || strings.registrationWarehouseAddress}
                    <br />
                    <Button
                        color="primary"
                        size="small"
                        onClick={this.onEditClick}
                        disabled={!canOpen}
                    >
                        {strings.registrationAddressUpdateButton}
                    </Button>
                </div>

                {!editing ? (
                    !country.name ||
                    !province ||
                    !city ||
                    !streetAddress ||
                    !streetNumber ||
                    !postalCode ? (
                        <div
                            style={{
                                color: 'red',
                                fontSize: '80%',
                                margin: 'auto',
                            }}
                        >
                            Faltan completar datos obligatorios
                        </div>
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                fontSize: '80%',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                marginTop: 10,
                            }}
                        >
                            {streetAddress +
                                ' ' +
                                streetNumber +
                                ' ' +
                                floor +
                                ' ' +
                                apartment +
                                ', ' +
                                postalCode +
                                ' ' +
                                city +
                                ', ' +
                                province.name +
                                ', ' +
                                country.name}
                        </div>
                    )
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: 10,
                        }}
                    >
                        <SelectSimple
                            label={formatReq(strings.country)}
                            options={countryList}
                            selectedOption={country}
                            handleChange={(x) => this.setState({ country: x })}
                            valueTag={'id'}
                            labelTag={'name'}
                            style={style.field}
                            error={errors.country}
                            disabled={true}
                        />
                        <SelectSimple
                            label={formatReq(strings.province)}
                            options={provinceList}
                            selectedOption={province}
                            handleChange={(x) => this.setState({ province: x })}
                            valueTag={'id'}
                            labelTag={'name'}
                            style={style.field}
                            error={errors.province}
                        />
                        <TextField
                            label={formatReq(strings.city)}
                            value={city}
                            onChange={(x) =>
                                this.setState({ city: x.target.value })
                            }
                            placeholder={strings.cityPlaceholder}
                            error={errors.city}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            style={style.field}
                        />

                        <TextField
                            label={formatReq(strings.streetAddress)}
                            value={streetAddress}
                            placeholder={strings.streetAddressPlaceholder}
                            onChange={(x) =>
                                this.setState({ streetAddress: x.target.value })
                            }
                            error={errors.streetAddress}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            style={style.field}
                        />

                        <TextField
                            label={formatReq(strings.streetNumber)}
                            value={streetNumber}
                            placeholder={strings.streetNumberPlaceholder}
                            onChange={(x) =>
                                this.setState({ streetNumber: x.target.value })
                            }
                            error={errors.streetNumber}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            style={style.field}
                        />

                        <TextField
                            label={formatReq(strings.postalCode)}
                            value={postalCode}
                            placeholder={strings.postalCodePlaceholder}
                            onChange={(x) =>
                                this.setState({ postalCode: x.target.value })
                            }
                            error={errors.postalCode}
                            InputLabelProps={{ shrink: true }}
                            style={style.field}
                        />

                        <TextField
                            label={strings.addressInfoDialogFloor}
                            value={floor}
                            placeholder={strings.floorPlaceholder}
                            onChange={(x) =>
                                this.setState({ floor: x.target.value })
                            }
                            error={errors.floor}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            style={style.field}
                        />

                        <TextField
                            label={strings.addressInfoDialogApartment}
                            value={apartment}
                            placeholder={strings.apartmentPlaceholder}
                            onChange={(x) =>
                                this.setState({ apartment: x.target.value })
                            }
                            error={errors.apartment}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            style={style.field}
                        />

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginTop: 20,
                            }}
                        >
                            <div style={{ flexGrow: 1 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitCancel}
                            >
                                {strings.dialogCancelLabel}
                            </Button>
                            <div style={{ width: 100 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitOk}
                            >
                                {strings.dialogOkLabel}
                            </Button>
                        </div>
                    </div>
                )}

                {!this.props.afterTitleComponent
                    ? null
                    : this.props.afterTitleComponent}
            </div>
        )
    }

    submitOk = () => {
        var data = this.submitOkData()
        if (!data) return
        this.props.onChange(data)
        this.props.toggleOpen(false)
        this.clearState(data)
    }

    submitCancel = () => {
        this.props.toggleOpen(false)
        this.clearState(this.props.initialValue)
    }

    onEditClick = () => {
        this.setState({ editing: true })
        this.props.toggleOpen(true)
    }

    clearState = (data) => {
        this.setState({
            ...this.initialState,
            ...data,
            ...{ country: this.state.country },
        })
    }

    componentDidMount() {}
}

export default Component
